import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const itemTypes = [
  { value: "standardCake", label: "Standard Cake" },
  { value: "specialtyCake", label: "Specialty Cake" },
  { value: "cheesecake", label: "Cheesecake" },
  { value: "grazeBox", label: "Graze Box" },
  { value: "macaron", label: "Macaron" },
  { value: "cookie", label: "Cookie" },
  { value: "cupcake", label: "Cupcake" },
  { value: "cakeSlice", label: "Cake Slice" },
  { value: "cheesecakeSlice", label: "Cheesecake Slice" },
  { value: "pastry", label: "Pastry" },
  { value: "other", label: "Other" },
];

const SharedTypeSelector = ({ item, updateItem }) => (
  <Grid item xs={12} sm={6}>
    <TextField
      select
      fullWidth
      label="Item Type"
      value={item.type || ""}
      onChange={(e) => updateItem(item._id, { type: e.target.value })}>
      {itemTypes.map((type) => (
        <MenuItem key={type.value} value={type.value}>
          {type.label}
        </MenuItem>
      ))}
    </TextField>
  </Grid>
);

export default SharedTypeSelector;
